import { Filter as FilterComponent } from "./Filter";
import { FilterChipWrapper } from "./FilterChipWrapper";
import { FilterPopover } from "./FilterPopover";

export const Filter = Object.assign(FilterComponent, {
  Chip: FilterChipWrapper,
  Popover: FilterPopover,
});
